'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.plpHeaderTemplate',
        '.filter-result-bar-container',
        '.search-result-number-mobile-container'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function updateScrollingHeight(filterApplied) {
    if (filterApplied) {
        $('.cc-filter-bar-mobile-scrolling').css('max-height', 'calc(100% - 172px)'); // consider also the reset button and products found
    } else {
        $('.cc-filter-bar-mobile-scrolling').css('max-height', 'calc(100% - 64px)'); // consider only the header
    }
}

function updateNumberOfFilters() {
    var filters = $('.filter-bar.active-filter-mobile').find('li');
    if (filters.length === 0 || filters.length === 1) {
        updateScrollingHeight(!!filters.length);
    }
    if (filters.length > 0) {
        $('.js-filter-counter').css('display', 'none');
        $('.js-updateNumberFilters').css('display', 'block');
        $('.js-plp-showFilters').addClass('d-none');
        $('.js-plp-activeFilters').removeClass('d-none');
        $('.js-updateNumberFilters').empty().html('( ' + filters.length + ' )');
    } else {
        $('.js-filter-counter').css('display', 'block');
        $('.js-updateNumberFilters').css('display', 'none');
        $('.js-plp-showFilters').removeClass('d-none');
        $('.js-plp-activeFilters').addClass('d-none');
    }
}
/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function changeWallLayout() {
    $('.js-wall-no-horizontal').each(function (index, element) {
        var $classesToChange = $('.js-wall-no-horizontal').closest('.row.cc-full-width-row').children();
        $classesToChange.removeClass('col-wall-33').removeClass('col-wall-66').removeClass('col-wall-50').addClass('col-wall-50');
    });
}

const footerElement = document.getElementsByTagName('footer')[0];
const viewportHeight = document.documentElement.clientHeight;

let replaceOrAddQueryParam = (url, parameter, value) => {
    var regex = new RegExp(parameter + '=[^&]+');
    var split = url.split(regex);
    if (split.length > 1) {
        return split[0] + (url.indexOf('?') > -1 ? '' : '?') + parameter + '=' + value + split[1];
    } else {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + parameter + '=' + value;
    }
};

let sizePage = (url, parameter, template) => {
    var split = url.split(parameter);
    if (split.length > 1) {
        var size = split[1].split('&')[0].split('=')[1];
        if (!template) {
            if (url.indexOf('template=search/wallShopByLookTemplate') !== -1) {
                if (parseInt(size, 10) % 11 !== 0) {
                    var sizeToAdd = parseInt(size, 10) / 12;
                    return parseInt(size, 10) - sizeToAdd;
                }
            } else {
                if (parseInt(size, 10) % 12 !== 0) {
                    sizeToAdd = parseInt(size, 10) / 11;
                    return parseInt(size, 10) + sizeToAdd;
                }
            }
        } else {
            if (template.indexOf('search/wallShopByLookTemplate') !== -1) {
                if (parseInt(size, 10) % 11 !== 0) {
                    sizeToAdd = parseInt(size, 10) / 12;
                    return parseInt(size, 10) - sizeToAdd;
                }
            } else {
                if (parseInt(size, 10) % 12 !== 0) {
                    sizeToAdd = parseInt(size, 10) / 11;
                    return parseInt(size, 10) + sizeToAdd;
                }
            }
        }
    } else {
        if (!template) {
            if (url.indexOf('template=search/wallShopByLookTemplate') !== -1) {
                return 11;
            } else return 12;
        } else {
            if (template.indexOf('search/wallShopByLookTemplate') !== -1) {
                return 11;
            } else return 12;
        }
    }
};

function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDiseble() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}
function liveChatPositionStikyUp() {
    var stikyHeight = $('.sticky-bar-mobile').height();
    if (window.isMobile) {
        if ($('.js-sticky-look-container').length > 0) {
            var height = $('js-sticky-add-to-cart-look').height();
            $('.helpButton, #embeddedMessagingConversationButton').css({
                bottom: height,
                right: '16px'
            });
            if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: '60px'
                });
            }
        } else {
            $('.helpButton, #embeddedMessagingConversationButton').css({
                bottom: stikyHeight,
                right: '16px'
            });
        }
    }
}
function liveChatPositionStikyDown() {
    if ($('.js-sticky-look-container').length > 0) {
        var height = $('.js-sticky-add-to-cart-look').height();
        if (window.isMobile) {
            $('.helpButton, #embeddedMessagingConversationButton').css({
                bottom: height,
                right: '16px'
            });
        } else {
            $('.helpButton, #embeddedMessagingConversationButton').css({
                bottom: height * 1.5,
                right: '16px'
            });
        }
    } else {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: '16px',
            right: '16px'
        });
        if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
            $('.helpButton, #embeddedMessagingConversationButton').css({
                bottom: '60px'
            });
        }
    }

};

const openMobileSortingWindow = () => {
    $('#mobileSortingWindow').removeClass('d-none');
    $('#mobileSortingWindow').css({
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 999
    });
    $('body').addClass('cc-blocked');
};

const closeMobileSortingWindow = () => {
    $('#mobileSortingWindow').addClass('d-none');
    $('#mobileSortingWindow').css({
        position: '',
        top: '',
        right: '',
        bottom: '',
        left: '',
        zIndex: ''
    });
    $('body').removeClass('cc-blocked');
};
function focusDivElement($selector) {
    const FOCUSABLE = 'button:not(:disabled):not([aria-hidden],input)';
    $selector.hover(function() {
        this.focus();
    }, function() {
        this.blur();
    }).keydown(function(event) {
        if (event.keyCode !== 9) {
            return;
        }
        let focusableNodes = $selector.find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
        const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
        if (event.shiftKey && focusedItemIndex === 0) {
            focusableNodes[focusableNodes.length - 1].focus();
            event.preventDefault();
        }
        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1) {
            focusableNodes[0].focus();
            event.preventDefault();
        }
    });
}
function getQueryParams(){
    var url = document.location.href;
    var qs = url.substring(url.indexOf('?') + 1).split('&');
    for(var i = 0, result = {}; i < qs.length; i++){
        qs[i] = qs[i].split('=');
        result[qs[i][0]] = decodeURIComponent(qs[i][1]);
    }
    return result;
}

function applyAccessibilityFix() {
    var $selectElement = $('#sortBy');
    var $buttonElement = $selectElement.next('button');
    
    var selectId = $selectElement.attr('id');
    var ariaControls = $selectElement.attr('aria-controls');

    $selectElement.removeAttr('aria-controls');
    
    $buttonElement.attr('id', selectId + "Button");
    $buttonElement.attr('aria-controls', ariaControls);
    $buttonElement.attr('tabindex', "0");
}

function handleBtnAccessibilityFunction(){
    $('.btn').on("focusout", function() {
        setTimeout(function () {
            $('.btn').attr('tabindex', "0");
        }, 100);
    });
}

module.exports = {

    handleBtnAccessibility: function(){
        // Call the function to make selectpicker button focussable
        handleBtnAccessibilityFunction();
    },

    // Necessary because of selectpicker
    fixAccessibilitySelectpicker: function() {
        $(document).ready(function() {
            // When the document is ready, change selectpicker behaviour to make it accessible
            applyAccessibilityFix();
        });
    },
	

    sortDesktop: function () {
        // Handle sort order menu selection
        $('body').on('change', '#sortBy', function (e) {
            e.preventDefault();

            var currTemplate = $('#productNumberHidden').data('currtemplate');

            $.spinner().start();
            $(this).trigger('search:sort', this.dataset.href);

            const $selectedOption = $(this);
            var optionSelect = $(this).children(':selected').attr('id');
            var kindSort;
            switch (optionSelect) {
            case 'price-ascending':
                kindSort = 'price ascend';
                break;
            case 'Online Timestamp':
                kindSort = 'new arrival';
                break;
            default:
                kindSort = 'price descend';
            }
            let url = $(this).val();
            let urlWithNewTemplate = replaceOrAddQueryParam(url, 'template', currTemplate);

            var actualQueryParam = getQueryParams();

            var queryTemplate = actualQueryParam && actualQueryParam.template ? actualQueryParam.template : null;

            // $('.js-sorting-option').removeClass('sorting-option-selected');
            $.ajax({
                url: urlWithNewTemplate,
                data: { isSwitch: true },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    changeWallLayout();
                    $.spinner().stop();
                    var link = decodeURI($('.permalink').val());
                    if (optionSelect !== null) {
                        link = replaceOrAddQueryParam(link, 'srule', optionSelect);
                    }
                    if (queryTemplate !== null) {
                        link = replaceOrAddQueryParam(link, 'template', queryTemplate);
                    }
                    window.history.replaceState('', '', link);
                    var isPageDesignerPLP = $('#js-is-plp').val();
                    if (isPageDesignerPLP) {
                        var urlPath = document.location.href;
                        var newUrlPath = replaceOrAddQueryParam(urlPath, 'template', $('.plpHeaderTemplate').attr('data-currenttemplate'));
                        var urlSwitch = $('.js-switch-container-plp.cc-selected').find('button').data('urlswitch');
                        newUrlPath = replaceOrAddQueryParam(newUrlPath, 'type', urlSwitch);
                        window.history.replaceState('', '', newUrlPath);
                    }
                    // Select the current option
                    // $selectedOption.addClass('sorting-option-selected');
                    // $('.js-selected-sorting-option').text($selectedOption.text());

                    // Remove CLS min-height
                    $(document).find('.cc-min-height-tile').removeClass('cc-min-height-tile');

                    // reload iframes with no lazysizes library
                    $(document).trigger('listingpage:reloadiframes');

                    // analytics plp sort
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'filter',
                        eventAction: 'sort',
                        eventLabel: kindSort,
                        filerType: 'sort',
                        filterValue: kindSort
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            }).done(() => $('body').trigger('wishlist:productsChangePLP'));
        });
    },

    sortMobile: function () {
        // Handle sort order menu selection
        $('body').on('change', '.js-sorting-option-mobile', function (e) {
            e.preventDefault();
            var optionSelect = $(this).data('id');
            var kindSort;
            switch (optionSelect) {
            case 'price-ascending':
                kindSort = 'price ascend';
                break;
            case 'Online Timestamp':
                kindSort = 'new arrival';
                break;
            default:
                kindSort = 'price descend';
            }
            var currTemplate = $('#productNumberHidden').data('currtemplate');
            $(this).trigger('search:sort', this.dataset.href);
            let url = this.dataset.href;
            let urlWithNewTemplate = replaceOrAddQueryParam(url, 'template', currTemplate);
            $.spinner().start();
            $.ajax({
                url: urlWithNewTemplate,
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    changeWallLayout();
                    $.spinner().stop();
                    var link = decodeURI($('.permalink').val());
                    window.history.replaceState('', '', link);
                    // Close the sorting window (mobile)
                    closeMobileSortingWindow();
                    liveChatEnable();
                    // reload iframes with no lazysizes library
                    $(document).trigger('listingpage:reloadiframes');

                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'filter',
                        eventAction: 'sort',
                        eventLabel: kindSort,
                        filerType: 'sort',
                        filterValue: kindSort
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(document).on('click', '.show-more a', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).attr('href');
            var actionType = $(this).data('action');
            var currTemplate = $(this).data('currtemplate');
            var isPageDesignerLook = $('#js-is-look').val();
            var startIndex = parseInt(new URLSearchParams(showMoreUrl).get('start'));

            $('#noIndex').remove();
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl,
                    action: actionType,
                    template: currTemplate,
                    isSwitch: true
                },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    changeWallLayout();
                    $.spinner().stop();
                    var link = decodeURI($('.permalink').val());
                    var positionTemplate = document.location.href.indexOf('template');
                    var template = positionTemplate !== -1 ? document.location.href.substr(positionTemplate) : '';
                    if (isPageDesignerLook !== 'true') {
                        if (template !== '') {
                            link = link + '&' + template.split('&')[0];
                        }
                        window.history.replaceState('', '', link);
                    } else {
                        var positionLinkSize = link.indexOf('sz');
                        var pageSize = positionLinkSize !== -1 ? (link.split('sz=')[1]).split('&')[0] : '';
                        link = replaceOrAddQueryParam(document.location.href, 'start', 0);
                        link = replaceOrAddQueryParam(link, 'sz', pageSize);
                        if (template !== '' && link.indexOf('template=') === -1) {
                            link = link + '&' + template.split('&')[0];
                        }
                        window.history.replaceState('', '', link);
                        if ($('body').hasClass('veiled')) {
                            $('body').removeClass('veiled');
                        }
                        if ($('.plpHeaderTemplate').attr('data-currenttemplate') === 'search/gridShopByLookTemplate') {
                            $('.cc-grid-shopbylook-tile').find('img').css('height', 'unset');
                        } else $('.cc-wall-big-tile-margin').find('img').css('height', 'unset');
                    }

                    dataLayer.push({
                        event: 'loadMore',
                        eventCategory: 'Load More'
                    });
                    // accessibility: move focus on the first new loaded product
                    $('.js-singleItem-plp').eq(startIndex).find('.js-pdp-variant-link').focus();
                    // reload iframes with no lazysizes library
                    $(document).trigger('listingpage:reloadiframes');
                    $('body').trigger('wishlist:showMorePLP', [{startIndex: startIndex}]);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button,.refinements li input, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .removeAll-active-filter',
            function (e) {
                var $tabPanel = $(this).closest('.content-filter-panel');
                if ($tabPanel.length > 0) {
                    var refinment = $(this).data('filter');
                    var type;
                    if (refinment.toLowerCase().indexOf('category') > -1) {
                        type = 'category';
                    }
                    if (refinment.toLowerCase().indexOf('color') > -1) {
                        type = 'color';
                    }
                    if (refinment.toLowerCase().indexOf('season') > -1) {
                        type = 'collection';
                    }
                    if (refinment.toLowerCase().indexOf('size') > -1) {
                        type = 'size';
                    }
                    if (refinment.toLowerCase().indexOf('gender') > -1) {
                        type = 'linea';
                    }
                    var refinmentValue = $(this).data('analyticsvalue');
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'filter',
                        eventAction: type,
                        eventLabel: refinmentValue,
                        filerType: type,
                        filterValue: refinmentValue
                    });
                }

                var currTemplate = $('#productNumberHidden').data('currtemplate');
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();
                $(this).trigger('search:filter', e);
                var actualQueryParam = getQueryParams();
                if (actualQueryParam) {
                    var srule = actualQueryParam.srule || null;
                    var queryTemplate = actualQueryParam.template || null;
                }
                var srulePresent = $(this).data('href').indexOf('srule') != -1;

                var data = {
                    template: currTemplate,
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href'),
                    isSwitch: true,
                    queryTemplate: queryTemplate,
                    isMobile: window.isMobile
                }
                if (srulePresent) {
                    data.srule = srule
                }

                $.ajax({
                    url: $(this).data('href'),
                    data: data,
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        updateNumberOfFilters();
                        changeWallLayout();
                        var link = decodeURI($('.permalink').val());
                        if (srule !== null) {
                            link = replaceOrAddQueryParam(link, 'srule', srule);
                        }
                        if (queryTemplate !== null) {
                            link = replaceOrAddQueryParam(link, 'template', queryTemplate);
                        }
                        window.history.replaceState('', '', link);
                        $('#sortBy').selectpicker();
                        $.spinner().stop();
                        var isPageDesignerPLP = $('#js-is-plp').val();
                        if (isPageDesignerPLP) {
                            var urlPath = document.location.href;
                            var newUrlPath = replaceOrAddQueryParam(urlPath, 'template', $('.plpHeaderTemplate').attr('data-currenttemplate'));
                            var urlSwitch = $('.js-switch-container-plp.cc-selected').find('button').data('urlswitch');
                            newUrlPath = replaceOrAddQueryParam(newUrlPath, 'type', urlSwitch);
                            window.history.replaceState('', '', newUrlPath);
                        }
                        if (srule !== null) {
                            $(document).find('#sortBy option[id="' + srule + '"]').prop('selected', true);
                            $('#sortBy').selectpicker('refresh');
                        }
                        
                        // Announce to Screen Reader the number of products found
                        $('.js-sr-announce-filter').text($('.js-sr-announce-filter').attr('data-product-count'));
                        $('.js-sr-announce-filter').attr("aria-label", $('.js-sr-announce-filter').attr('data-product-count'));
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                }).done(function(){ $('body').trigger('wishlist:productsChangePLP'); $(".js-sr-announce-filter").focus()});
            });
    },

    filteModalOpen: function () {
        $(document).on('click', '.js-open-filter-plp', function () {
            $('#filter-modal-plp').addClass('cc-visible');
            $('.js-open-filter-plp').addClass('d-none');
            $('.js-close-filter-plp').removeClass('d-none');
            $('.cc-row-filter-modal').addClass('cc-open');
            var $elements = $('.cc-row-filter-modal .mainFilterContainer').find('button:not(:disabled):not([aria-hidden]),a[href],input').toArray();
            $elements[0].focus();
            focusDivElement($('.cc-row-filter-modal #filter-modal-plp .mainFilterContainer'));
            // close tile overlay
            var plus = $('.js-open-size-color').data('plus');
            $('.js-close-size-color').removeClass('js-close-size-color').addClass('js-open-size-color');
            $('.js-change-icon').each(function() {
                $(this).children().attr('xlink:href', plus);
            });
            $('.cc-size-color-modal').each(function () {
                $(this).removeClass('cc-open');
                if ($(this).css('opacity') === '1') {
                    var currentID = $(this).data('pid');
                    $('.openTab-' + currentID).removeClass('d-none');
                    $('.closeTab-' + currentID).addClass('d-none');
                }
            });
            $(document).find('.cc-min-height-tile').removeClass('cc-min-height-tile');
        });
    },

    filteModalClose: function () {
        $(document).on('click', '.js-close-filter-plp', function () {
            $('#filter-modal-plp').removeClass('cc-visible');
            $('.js-close-filter-plp').addClass('d-none');
            $('.js-open-filter-plp').removeClass('d-none');
            $('.cc-row-filter-modal').removeClass('cc-open');
            $('.show-filter-text').focus(); // Adding focus for accessibility            
        });
    },

    widthSortingDiv: function () {
        $(document).ready(function () {
            $('#myDropdown').css('width', $('#sorting-button').width());
        });
    },

    sortingOptionList: function () {
        $(document).on('click', '#sorting-button', function () {
            document.getElementById('myDropdown').classList.toggle('show');
        });
    },

    closeSortingOptionList: function () {
        window.onclick = function (event) {
            if (!event.target.matches('.dropbtn')) {
                var dropdowns = document.getElementsByClassName('dropdown-content');
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }
        };
    },

    changeTemplateViewContainer: function () {
        $(document).on('click', '.js-change-layout-container', function () {
            var templateData = $(this);
            var currenSorting = $('#sortBy').siblings('button').attr('title');
            var isSearch = $('#js-is-search').val();
            var isPageDesignerLook = $('#js-is-look').val();
            if (isSearch === undefined || isSearch == 'false') {
                $('.plpHeaderTemplate').attr('data-currenttemplate', $(templateData).data('pid'));
                $('.plpHeaderTemplate').data('currenttemplate', $(templateData).data('pid'));
                $.spinner().start();
                var urlPath = document.location.href;
                if (isPageDesignerLook === 'true') {
                    var urlPathLook = $('.js-switch-container-plp.cc-selected').find('button').data('href');
                    urlPathLook = replaceOrAddQueryParam(urlPathLook, 'template', $(templateData).data('pid'));
                    var sizeOfPage = sizePage(urlPath, 'sz', $(templateData).data('pid'));
                    urlPathLook = replaceOrAddQueryParam(urlPathLook, 'start', 0);
                    urlPathLook = replaceOrAddQueryParam(urlPathLook, 'sz', sizeOfPage);
                }
                var newUrlPath = replaceOrAddQueryParam(urlPath, 'template', $(templateData).data('pid'));
                $.ajax({
                    url: urlPathLook || newUrlPath,
                    data: { isSwitch: true },
                    method: 'GET',
                    success: function (response) {
                        var analyticsTemplate;
                        var templateName = '';

                        if (!isPageDesignerLook) {
                            parseResults(response);
                            changeWallLayout();
                            $('#sortBy').prop('title', currenSorting);
                            $('#sortBy').selectpicker();
                            $.spinner().stop();
                            newUrlPath = replaceOrAddQueryParam(newUrlPath, 'start', 0);
                            newUrlPath = replaceOrAddQueryParam(newUrlPath, 'sz', $('#size-page').val());
                            window.history.replaceState('', '', newUrlPath);
                            $('body').trigger('analytics:changeTemplateProduct');
                            var template = $(templateData).data('pid');
                            switch (template) {
                            case 'search/grid3Template': templateName = 'grid3';
                                break;
                            case 'search/grid2Template': templateName = 'grid2';
                                break;
                            case 'search/wallTemplate': templateName = 'wall';
                                break;
                            }
                            analyticsTemplate = templateName;
                            if (analyticsTemplate === '') {
                                switch (template) {
                                case 'search/gridShopByLookTemplate': analyticsTemplate = 'gridShopByLook';
                                    break;
                                case 'search/wallShopByLookTemplate': analyticsTemplate = 'wallShopByLook';
                                    break;
                                }
                            }
                            // analytics
                            if ($(document).find('.cc-double-image .cc-tile-image--second').length > 0) {
                                templateName += '-hover';
                            }

                            dataLayer.push({
                                event: 'dynamic_page',
                                listingType: analyticsTemplate
                            });

                            $('body').trigger('analytics:pushpagechange', { listingType: templateName });
                        } else {
                            parseResults(response);
                            changeWallLayout();
                            if ($(templateData).data('pid') === 'search/gridShopByLookTemplate') {
                                $('.cc-grid-shopbylook-tile').find('img').css('height', 'unset');
                            } else $('.cc-wall-big-tile-margin').find('img').css('height', 'unset');
                            $.spinner().stop();
                            if ($('body').hasClass('veiled')) {
                                $('body').removeClass('veiled');
                            }
                            var size = sizePage(newUrlPath, 'sz', null);
                            newUrlPath = replaceOrAddQueryParam(newUrlPath, 'start', 0);
                            newUrlPath = replaceOrAddQueryParam(newUrlPath, 'sz', size);
                            window.history.replaceState('', '', newUrlPath);
                            $('body').trigger('analytics:changeTemplateProduct');

                            // analytics
                            var urlSwitch = $(document).find('.js-switch-plp-look.js-is-look-switch').data('urlswitch');
                            var currentTemplate = $(document).find('.plpHeaderTemplate').data('currenttemplate');
                            switch (currentTemplate) {
                            case 'search/gridShopByLookTemplate':
                                templateName = 'gridShopByLook';
                                analyticsTemplate = 'gridShopByLook';
                                break;

                            case 'search/wallShopByLookTemplate':
                                templateName = 'wallShopByLook';
                                analyticsTemplate = 'wallShopByLook';
                                break;
                            }

                            dataLayer.push({
                                event: 'dynamic_page',
                                listingType: analyticsTemplate
                            });

                            $('body').trigger('analytics:pushpagechange', {
                                pageCategory: 'product-list',
                                pagesubCategory: urlSwitch,
                                pageDetail: 'shop-by-look',
                                listingType: templateName
                            });
                        }
                        // Remove CLS min-height
                        $(document).find('.cc-min-height-tile').removeClass('cc-min-height-tile');

                        if (!('loading' in HTMLImageElement.prototype)) {
                            const images = document.querySelectorAll('img[loading="lazy"]');
                            images.forEach(img => {
                                const urls1 = $(img).siblings().eq(0).attr('srcset');
                                const urls2 = $(img).siblings().eq(1).attr('srcset');
                                const imgUrl = $(img).attr('srcset');
                                if (urls1 && urls2) {
                                    $(img).siblings().eq(0).removeAttr('srcset').attr('data-srcset', urls1);
                                    $(img).siblings().eq(1).removeAttr('srcset').attr('data-srcset', urls2);
                                }
                                if (imgUrl) {
                                    $(img).removeAttr('srcset').attr('data-srcset', imgUrl);
                                }
                            });
                        } else {
                            // reload iframes with no lazysizes library
                            $(document).trigger('listingpage:reloadiframes');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                }).done(function() {$('body').trigger('wishlist:productsChangePLP'); applyAccessibilityFix(); handleBtnAccessibilityFunction();});
            } else {
                // isSearch is true
                var url = $(templateData).data('href') + '?cgid=' + $(templateData).data('cgid') + '&q=' + $(templateData).data('q') + '&template=' + $(templateData).data('pid');
                $('.plpHeaderTemplate').data('currenttemplate', $(templateData).data('pid'));
                $.spinner().start();
                var urlPath = document.location.href;
                var newUrl = replaceOrAddQueryParam(window.location.href, 'template', $(templateData).data('pid'));
                var newUrlPath;
                $.ajax({
                    url: newUrl,
                    data: { isSwitch: true },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $('#sortBy').prop('title', currenSorting);
                        $('#sortBy').selectpicker();
                        changeWallLayout();
                        $.spinner().stop();
                        newUrlPath = replaceOrAddQueryParam(urlPath, 'template', $(templateData).data('pid'));
                        newUrlPath = replaceOrAddQueryParam(newUrlPath, 'start', 0);
                        newUrlPath = replaceOrAddQueryParam(newUrlPath, 'sz', $('#size-page').val());
                        window.history.replaceState('', '', newUrlPath);
                        $('body').trigger('analytics:changeTemplateProduct');

                        // analytics
                        var template = $(templateData).data('pid');
                        var templateName = '';
                        switch (template) {
                        case 'search/grid3Template': templateName = 'grid3';
                            break;
                        case 'search/grid2Template': templateName = 'grid2';
                            break;
                        case 'search/wallTemplate': templateName = 'wall';
                            break;
                        }
                        var analyticsTemplate = templateName;
                        if (analyticsTemplate === '') {
                            switch (template) {
                            case 'search/gridShopByLookTemplate': analyticsTemplate = 'gridShopByLook';
                                break;
                            case 'search/wallShopByLookTemplate': analyticsTemplate = 'wallShopByLook';
                                break;
                            }
                        }
                        dataLayer.push({
                            event: 'dynamic_page',
                            listingType: analyticsTemplate
                        });

                        if (!('loading' in HTMLImageElement.prototype)) {
                            const images = document.querySelectorAll('img[loading="lazy"]');
                            images.forEach(img => {
                                const urls1 = $(img).siblings().eq(0).attr('srcset');
                                const urls2 = $(img).siblings().eq(1).attr('srcset');
                                const imgUrl = $(img).attr('srcset');
                                if (urls1 && urls2) {
                                    $(img).siblings().eq(0).removeAttr('srcset').attr('data-srcset', urls1);
                                    $(img).siblings().eq(1).removeAttr('srcset').attr('data-srcset', urls2);
                                }
                                if (imgUrl) {
                                    $(img).removeAttr('srcset').attr('data-srcset', imgUrl);
                                }
                            });
                        } else {
                            // reload iframes with no lazysizes library
                            $(document).trigger('listingpage:reloadiframes');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    openSortingDivMobile: function () {
        $(document).on('click', '.sorting-button', function () {
            openMobileSortingWindow();
            liveChatDiseble();
        });
    },

    closeSortingDivMobile: function () {
        $(document).on('click', '.closeSortingWindow', function () {
            closeMobileSortingWindow();
            liveChatEnable();
        });
    },

    openFilterDivMobile: function () {
        $(document).on('click', '.filter-button', function () {
            $('#mobileFilterWindow').removeClass('d-none');
            $('#mobileFilterWindow').css({
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 999
            });
            $('body').addClass('cc-blocked');
            liveChatDiseble();
        });
    },

    closeFilterDivMobile: function () {
        $(document).on('click', '.closeFilterWindow', function () {
            $('#mobileFilterWindow').addClass('d-none');
            $('#mobileFilterWindow').css({
                position: '',
                top: '',
                right: '',
                bottom: '',
                left: '',
                zIndex: ''
            });
            $('body').removeClass('cc-blocked');
            liveChatEnable();
        });
    },

    showOverlayWallHover: function () {
        $(document).on({
            mouseenter: function () {
                var id = $(this).data('id');
                //  $('.overlay-wall-' + id).removeClass('d-none');
                $('.overlay-wall-' + id).css('opacity', '1');
            },
            mouseleave: function () {
                var id = $(this).data('id');
                //  $('.overlay-wall-' + id).addClass('d-none');
                $('.overlay-wall-' + id).css('opacity', '0');
            }
        }, '.cc-desktop .image-container-wall');
    },

    closeMobileOverlayClickOnBody: function () {
        $(document).on('click', '.cc-mobile', function (event) {
            $('.js-mobileOverlay').each(function () {
                if ($(event.target).closest(this).length === 0) {
                    event.preventDefault();
                    $(this).removeClass('cc-open');
                    //  add href link to image
                    var id = $(this).data('productid');
                    var plus = $('.openTab-' + id).data('plus');
                    $('.openTab-' + id).removeClass('js-close-size-color').addClass('js-open-size-color');
                    $('.openTab-' + id).find('use').attr('xlink:href', plus);
                    $('.js-imageContainerWall-' + id).attr('href', $('.js-imageContainerWall-' + id).attr('rel'));
                    $('.js-imageContainerWall-' + id).removeAttr('rel');
                    $('.sizecolorTab-' + id).removeClass('js-mobileOverlay');
                }
            });
        });
    },

    showStickyBarPLP: function () {
        let scrollTimer;
        $(document).on('scroll', function () {
            if (scrollTimer) {
                clearTimeout(scrollTimer);
                liveChatPositionStikyDown();
            }
            var $plpBanner = $(document).find('.cc-pd-sticky-banner');
            if ($plpBanner.length > 0 && !$plpBanner.hasClass('custom-margin')) {
                $plpBanner.css('bottom', "0px");
            }
            let $sticky = $('.sticky-bar-mobile');
            var filterButtonHeigt =  $sticky.height() + 'px';
            let $liveAgentButton = $('.embeddedServiceHelpButton .helpButton');
            // $liveAgentButton.css('bottom', '58px!important');
            // $liveAgentButton.css('right', '10px!important');
            $liveAgentButton.addClass('cc-liveChat-button');
            $sticky.addClass('d-none');
            let isFooterVisible = footerElement.getBoundingClientRect().top < viewportHeight;
            let stickyCanAppear = !isFooterVisible;
            if (stickyCanAppear) {
                scrollTimer = setTimeout(() => {
                    if ($plpBanner.length > 0 && !$plpBanner.hasClass('custom-margin')) {
                        $plpBanner.css('bottom', filterButtonHeigt);
                    }
                    $sticky.removeClass('d-none');
                    liveChatPositionStikyUp();
                }, 250);
            }
        });
    },

    changeWallLayoutOnLoad: function () {
        $(document).ready(changeWallLayout());
    },

    // atterraggio plp
    startpositionLiveChatButton: function() {
        $(document).ready(function() {
            liveChatPositionStikyUp();
        });
    },

    accessibilityWall: function() {
        $(document).on('focus', '.js-wall-tile .cc-overlay-wall', (e) => {
            const $tile = $(e.currentTarget);
            const pid = $tile.data('id');
            $('.cc-overlay-wall').css('opacity', '0');
            $('.overlay-wall-' + pid).css('opacity', '1');
            $('.social-wish-' + pid).css('opacity', '1');
        });
        $(document).on('focusout', '.js-wall-tile .cc-overlay-wall', (e) => {
            $('.cc-overlay-wall').css('opacity', '0');
        });
    },

    setHistoryStatus: function () {
        $(document).on('click', 'a', function () {
            window.history.pushState({ scrollTop: window.scrollY }, 'scroll');
        });
    },

    reloadIframes: function() {
        $(document).on('listingpage:reloadiframes', function() {
            // reload iframes with no lazysizes library
            const iframes = document.querySelectorAll('iframe.lazyload');
            iframes.forEach(video => {
                let endPoint = $(video).eq(0).attr('data-video-url');
                if (endPoint) {
                    if ($(video).hasClass('cloudinary')) {
                        video.setAttribute('src', endPoint);
                    } else {
                        $.ajax({
                            url: endPoint,
                            success: function(data) {
                                video.setAttribute('src', data.videoURL);
                            }
                        });
                    }
                }
            });
        });
    }
};
